<template>
  <!--begin::General Widget 1-->
  <v-container class="mb-10">
    <div class="">
      <div class="card-header border-0">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label page-title fw-bolder fs-3 mb-1"
            >Manage Delivery Cost (USD)</span
          >
        </h3>
      </div>
    </div>

    <div class="spacer-y-10"></div>

    <div class="card">
      <div class="card-body py-10">
        <div class="tab-content">
          <!--begin::Tap pane-->
          <div class="tab-pane fade show active" id="kt_table_widget_5_tab_1">
            <div class="row">
              <div
                class="col-sm-6"
                v-for="(deliveryCost, index) in deliveryCosts"
                :key="deliveryCost.parish"
              >
                <DeliveryCostInput
                  v-model="deliveryCosts[index]"
                  @updateDeliveryCost="updateDeliveryCost"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
    </div>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="confirmationAccept"
      @eCancel="confirmationReject"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </v-container>
  <!--end::General Widget 1-->
</template>
<script>
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import mixins from "vue-typed-mixins";
import DeliveryCostInput from "@/components/DeliveryCostInput.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "ManageDeliveryCost",
  data() {
    return {
      loadingConfig: false,
      deliveryCosts: [],
    };
  },
  components: {
    DeliveryCostInput,
    SnackbarNotifier,
    ConfirmationModal,
  },
  methods: {
    async getDeliveryCosts() {
      try {
        this.loadingConfig = true;
        this.deliveryCosts = await ApiService.Instance.retrieveDeliveryCosts();
      } catch (e) {
        error(e);
      }
      this.loadingConfig = false;
    },
    async updateDeliveryCost({ id, parish, cost }) {
      try {
        const shouldUpdateDeliveryCost = await this.confirm({
          title: `${parish} Delivery Cost`,
          message: `Are you sure you want to update the ${parish} delivery cost to $${cost}?`,
        });

        if (!shouldUpdateDeliveryCost) {
          return;
        }
        this.startConfirmationLoading();

        await ApiService.Instance.updateDeliveryCost({
          id,
          cost,
        });

        this.stopConfirmationLoading();
        this.showNotifier({
          message: `${parish} delivery cost updated`,
          snackbarType: "success",
        });
      } catch (e) {
        this.stopConfirmationLoading();
        this.showNotifier({
          message: `Something went wrong updating the ${parish} delivery cost.`,
          snackbarType: "error",
        });
        error(e);
      }
    },
  },
  async beforeMount() {
    try {
      await this.getDeliveryCosts();
    } catch (e) {
      error(e);
    }
  },
});
</script>
